var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationProvider", {
    attrs: {
      vid: _vm.vid,
      name: _vm.$attrs.name || _vm.$attrs.label,
      rules: _vm.rules,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors, valid }) {
          return [
            _c(
              "b-field",
              _vm._b(
                {
                  attrs: {
                    type: { "is-danger": errors[0], "is-success": valid },
                    message: errors,
                  },
                },
                "b-field",
                _vm.$attrs,
                false
              ),
              [
                _c(
                  "b-input",
                  _vm._b(
                    {
                      model: {
                        value: _vm.innerValue,
                        callback: function ($$v) {
                          _vm.innerValue = $$v
                        },
                        expression: "innerValue",
                      },
                    },
                    "b-input",
                    _vm.$attrs,
                    false
                  )
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }